import React from 'react';
import { InputGroup } from 'react-bootstrap';
import { Field } from 'formik';
import PropTypes from 'prop-types';

export const UncoveredSurface = ({ errors, touched }) => (
  <div>
    <label>Superficie descubierta</label>
    <InputGroup size="sm" className="formWidths" style={{ maxWidth: '150px' }}>
      <InputGroup.Text id="basic-addon1">m2</InputGroup.Text>
      <Field className="form-control" name="surface.uncoveredSurface" />
    </InputGroup>
    {errors.surface?.uncoveredSurface && touched.surface?.uncoveredSurface && (
      <label className="w-100 text-danger mt-1">
        {errors.surface.uncoveredSurface}
      </label>
    )}
  </div>
);

UncoveredSurface.propTypes = {
  errors: PropTypes.object,
  touched: PropTypes.object
};
